<template>
	<v-card flat outlined>
		<v-container fluid class="pb-0">
			<v-row>
				<v-col cols="12" lg="12" class="pb-0 pt-0">
					<v-card flat class="pb-0 pt-0">
						<v-card-text class="pb-0">
							<v-row class="d-flex justify-space-between">
								<v-col></v-col>
								<v-col class="d-flex justify-center pb-0 pt-0">
									<v-card-title class="justify-center align-center pa-2 pb-0 pt-0">{{
										$t('titles.attendedCourses')
									}}</v-card-title>
								</v-col>
								<v-col class="d-flex justify-end pa-0 pl-2">
									<v-btn color="primary" @click="candidatesRegisterClick">
										<v-icon small>fa-file-excel</v-icon>&nbsp;&nbsp;{{
											$t('buttons.candidatesRegister')
										}}
									</v-btn>
								</v-col>
							</v-row>
							<v-row>
								<v-col class="pt-0">
									<TheTable
										:additional-filters="attendedCoursesTable.additionalFilters"
										:default-sort="attendedCoursesTable.defaultSort"
										:excel="true"
										:fields="attendedCoursesTable.headers"
										:header-selection-key="'attended-courses-headers'"
										:height="attendedCoursesTable.height"
										:total-records="attendedCoursesTable.total"
										:filter-save-key="'attended-courses-filters'"
										@excel="excelExport"
										@headers="selectHeaders"
										@reload="reloadData"
									>
										<tr
											v-for="(item, key) in attendedCoursesTable.items"
											:key="key"
											:class="{ 'cursor-pointer': true }"
										>
											<td v-if="attendedCoursesTable.selectedHeaders.includes('partner')">
												{{ item.partner }}
											</td>
											<td v-if="attendedCoursesTable.selectedHeaders.includes('course_code')">
												{{ item.course_code }}
											</td>
											<td v-if="attendedCoursesTable.selectedHeaders.includes('course')">
												{{ item.course }}
											</td>
											<td v-if="attendedCoursesTable.selectedHeaders.includes('code')">
												{{ item.code }}
											</td>
											<td v-if="attendedCoursesTable.selectedHeaders.includes('office')">
												{{ item.office }}
											</td>
											<td v-if="attendedCoursesTable.selectedHeaders.includes('start_date')">
												{{
													item.start_date != null
														? item.start_date.split('-').reverse().join('.')
														: ''
												}}
											</td>
											<td
												v-if="
													attendedCoursesTable.selectedHeaders.includes(
														'number_of_candidates'
													)
												"
											>
												{{ item.number_of_candidates }}
											</td>
										</tr>
									</TheTable>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'AttendedCourses',
	components: { TheTable },
	data: function () {
		return {
			attendedCoursesTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.partner'),
						value: 'partner',
						type: 'multiple|partners-buyers',
						allowFilter: true,
					},
					{
						text: this.$t('fields.code'),
						value: 'course_code',
						type: 'multiple|courses-codes',
						allowFilter: true,
					},
					{
						text: this.$t('fields.course'),
						value: 'course',
						type: 'multiple|courses',
						allowFilter: true,
					},
					{
						text: this.$t('fields.plannedCourse'),
						value: 'code',
						type: 'multiple|planned-courses-codes',
						allowFilter: true,
					},
					{
						text: this.$t('fields.office'),
						value: 'office',
						type: 'select_all|offices',
						allowFilter: true,
					},
					{
						text: this.$t('fields.date'),
						value: 'start_date',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.registration'),
						value: 'number_of_candidates',
						type: '',
						allowFilter: true,
					},
				],
				additionalFilters: [{ text: this.$t('fields.date'), value: 'start_date', type: 'date_range' }],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'partner_id',
					descending: true,
				},
			},
			incomeSum: 0,
			discountSum: 0,
		};
	},
	methods: {
		selectHeaders(headers) {
			this.attendedCoursesTable.selectedHeaders = headers;
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.attendedCoursesTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'attended-courses',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/attended-courses', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		candidatesRegisterClick() {
			let vm = this;
			let excelRequest = JSON.parse(JSON.stringify(this.attendedCoursesTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;
			vm.$APICall('post', 'excel/candidates-register', excelRequest, (data, success) => {
				window.open(data.link);
			});
		},
		reloadData(request) {
			this.attendedCoursesTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'attended-courses',
				request,
				(data, success) => {
					if (success) {
						vm.attendedCoursesTable.items = data.items;
						vm.attendedCoursesTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.attendedCoursesTable.height = window.innerHeight - 330 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		this.$myStore.commit('setBreadcrumbs', [{ text: this.$t('modules.stats'), href: '/#/stats', disabled: true }]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
